<template>
  <div>
    <b-modal
      ref="modalBemVindo"
      hide-footer
      size="lg"
      @hidden="modalClose"
    >
      <!-- <b-row
        class="mb-1"
      >
        <b-col cols="12">
          <b-img
            center
            rounded
            width="100"
            src="@/assets/images/logo/logo.png"
          />
        </b-col>
      </b-row> -->
      <b-row class="mb-2">
        <b-col>
          <h2 style="text-align: center;">
            Bem vindo ao Portal de Propostas</h2>
        </b-col>
      </b-row>
      <b-row class="mb-2">
        <b-col>
          <p style="text-align: center;">
            Aqui você acompanha/aprova suas propostas comerciais.</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <p style="text-align: center;">
            Clique nos botões abaixo para assistir nossa apresentação!</p>
        </b-col>
      </b-row>
      <b-row style="margin-bottom: 5rem !important;">
        <b-col
          cols="12"
          style="display: flex;justify-content: center;"
        >
          <b-btn
            variant="none"
            class="btn btn-primary btn-sm mr-1"
            :disabled="!nomeVideo || nomeVideo === ''"
            @click="abrirVideo"
          >
            <font-awesome-icon
              :icon="faPlay"
              class="mr-50"
            />Apresentação em vídeo
          </b-btn>
          <b-btn
            variant="none"
            class="btn btn-primary btn-sm"
            :disabled="!nomeArquivo || nomeArquivo === ''"
            @click="abrirArquivo"
          >
            <font-awesome-icon
              :icon="faPlay"
              class="mr-50"
            />Apresentação em arquivo
          </b-btn>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-checkbox
            v-model="marcado"
          >
            Não exibir essa mensagem novamente
          </b-checkbox>
        </b-col>
      </b-row>
    </b-modal>

    <visualizar-arquivo
      v-if="mostrarVisualizacaoArquivo || mostrarVisualizacaoVideo"
      :url="url"
      @hidden="fecharVisualizarArquivo()"
    />
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faPlay,
} from '@fortawesome/free-solid-svg-icons'
import api from '@/app-modulo/comercial/Parametrizacao/ParametrizacaoGeral/services/api'
import apiPessoa from '@/app-modulo/comercial/pessoa/shared/services/api'
import { getUserInfo } from '@/auth/utils'

export default {
  name: 'ModalBemVindo',
  components: {
    FontAwesomeIcon,
    VisualizarArquivo: () => import('@/shared/components/visualizar-arquivo/VisualizarArquivo.vue'),
  },
  data() {
    return {
      faPlay,
      marcado: false,
      mostrarVisualizacaoArquivo: false,
      mostrarVisualizacaoVideo: false,
      url: '',
      nomeVideo: '',
      nomeArquivo: '',
    }
  },
  mounted() {
    this.$refs.modalBemVindo.show()
  },
  created() {
    api.getParametrizacaoResumidaPortal()
      .then(payload => {
        this.nomeVideo = payload.data.nomeVideo
        this.nomeArquivo = payload.data.nomeArq
      })
  },
  methods: {
    modalClose() {
      if (this.marcado) {
        apiPessoa.salvarMensagem(getUserInfo().id)
          .then()
          .catch(err => {
            throw err
          })
      }
    },
    abrirVideo() {
      api.getUrlVideoPortal()
        .then(payload => {
          this.url = payload.data
          this.mostrarVisualizacaoVideo = true
        })
    },
    abrirArquivo() {
      api.getUrlArquivoPortal()
        .then(payload => {
          this.url = payload.data
          this.mostrarVisualizacaoArquivo = true
        })
    },
    fecharVisualizarArquivo() {
      this.mostrarVisualizacaoArquivo = false
      this.mostrarVisualizacaoVideo = false
    },
  },
}
</script>
